import React from 'react';
export function StatsStrip() {
  return <div className="bg-rosa text-white py-4 sm:py-5 px-4 sm:px-5 flex justify-center gap-6 sm:gap-10 flex-wrap text-center" data-id="element-324">
      <div className="flex flex-col" data-id="element-325">
        <strong className="text-[26px] font-extrabold leading-tight" data-id="element-326">
          +400
        </strong>
        <span className="text-[12px] opacity-85 uppercase tracking-wider" data-id="element-327">
          Esteticistas
        </span>
      </div>
      <div className="flex flex-col" data-id="element-328">
        <strong className="text-[26px] font-extrabold leading-tight" data-id="element-329">
          4.9
        </strong>
        <span className="text-[12px] opacity-85 uppercase tracking-wider" data-id="element-330">
          Rating
        </span>
      </div>
      <div className="flex flex-col" data-id="element-331">
        <strong className="text-[26px] font-extrabold leading-tight" data-id="element-332">
          150+
        </strong>
        <span className="text-[12px] opacity-85 uppercase tracking-wider" data-id="element-333">
          Páginas aplicables
        </span>
      </div>
      <div className="flex flex-col" data-id="element-334">
        <strong className="text-[26px] font-extrabold leading-tight" data-id="element-335">
          Todo Argentina
        </strong>
        <span className="text-[12px] opacity-85 uppercase tracking-wider" data-id="element-336">
          Mercado Pago
        </span>
      </div>
    </div>;
}